import React, { useEffect, useState } from 'react'

const MultiselectCheckbox = ({ onChange, options, className = '', value = [] }) => {
    const valueSet = new Set(value);
    return (
        <div className={`multiselect-checkbox ${className}`}>
            {options.map(opt => {

                return <label>
                    <input type='checkbox' className='mr-1' checked={valueSet.has(opt)} onChange={e => {
                        const checked = e.target.checked;
                        if (checked) {
                            onChange([...value, opt]);
                        } else {
                            onChange(value.filter(sv => sv !== opt));
                        }
                    }}></input>
                    {opt}
                </label>
            })}
        </div>
    )
}

export default MultiselectCheckbox